import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../../../components/ButtonRounded";
import ModalContainer from "../../../../components/ModalContainer";
import { FormattedMessage } from "react-intl";
import {useModalConfirmStyles} from "../../../../common/styles/modalStyles";

const useStyles = useModalConfirmStyles;

interface ModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalConfirmDelivery: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      title={
        <div className={classes.titleContainer}>
          <div>
            <FormattedMessage id="sustainabilityView.reportsView.modal.confirmDelivery.title1" />
          </div>
          <div>
            <FormattedMessage id="sustainabilityView.reportsView.modal.confirmDelivery.title2" />
          </div>
        </div>
      }
    >
      <div className={classes.modalContent}>
        <Grid container spacing={2} className={classes.btnContainer}>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="outlined"
              onClick={onClose}
              color="default"
            >
              <FormattedMessage id="sustainabilityView.reportsView.modal.confirmDelivery.button.no" />
            </ButtonRounded>
          </Grid>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="contained"
              color="primary"
              onClick={onConfirm}
            >
              <FormattedMessage id="sustainabilityView.reportsView.modal.confirmDelivery.button.yes" />
            </ButtonRounded>
          </Grid>
        </Grid>
      </div>
    </ModalContainer>
  );
};

export default ModalConfirmDelivery;
